import { render, staticRenderFns } from "./CheckWinner.vue?vue&type=template&id=26587987&scoped=true"
import script from "./CheckWinner.vue?vue&type=script&lang=js"
export * from "./CheckWinner.vue?vue&type=script&lang=js"
import style0 from "./CheckWinner.vue?vue&type=style&index=0&id=26587987&prod&lang=scss"
import style1 from "./CheckWinner.vue?vue&type=style&index=1&id=26587987&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26587987",
  null
  
)

export default component.exports